<script>
  import { createEventDispatcher } from "svelte"
  import SuggestionContent from "./Components/suggestionContent.svelte"
  const dispatch = createEventDispatcher()
  export let parsedJson
  export let editorValues

  let disableBtn
  let form
  let editorObj = {}

  const handleSubmit = () => {
    const data = new FormData(form)
    let formData = [...data]
    for (let i = 0; i < editorValues.length; i++) {
      editorObj[editorValues[i]] = ""
    }

    for (let i = 0; i < formData.length; i++) {
      let tempValue = formData[i][1]
      if (tempValue != "None") editorObj[formData[i][0]] = editorObj[formData[i][0]] ? `${editorObj[formData[i][0]]}_${tempValue}` : tempValue
    }
    disableBtn = !disableBtn
    dispatch("applyAndContinue", editorObj)
  }
</script>

<div class="fixed inset-0 z-50 h-screen w-screen select-none overflow-auto bg-[#f7f7f7]/50 backdrop-blur-md dark:bg-bodyblack/50">
  <div class="flex h-auto min-h-screen flex-col items-center justify-center gap-6 p-6">
    <div class="m-6 h-auto w-[400px] rounded-md bg-white text-left shadow-xl dark:bg-bodyblack sm:w-[500px] md:m-0 md:w-[700px]">
      <form bind:this={form} on:submit|preventDefault>
        <div class="flex w-full items-center justify-center rounded-md bg-white p-6 text-black dark:bg-bodyblack">
          <h1 class="select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Invalid attributes Found</h1>
        </div>

        <p class="mb-10 select-none px-10 text-center text-base font-medium text-gray-200">Below are the suggestions for the invalid email attributes based on the document template you already chosen</p>
        <div class="mx-auto w-8/12">
          {#each editorValues as editorValues}
            <button class="flex w-full items-center rounded-md">
            <!-- <button class="flex w-full items-start rounded-md"> -->
              <div class="w-2/6 select-none truncate p-2 text-start dark:text-slate-200">{editorValues}</div>
              <SuggestionContent bind:disableBtn {parsedJson} {editorValues} />
            </button>
          {/each}
        </div>

        <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-white p-6 dark:bg-bodyblack sm:flex md:gap-0">
          <button
            on:click={() => {
              dispatch("closeModal")
            }}
            class="group flex h-9 min-h-full min-w-[36px] items-center justify-center gap-2 rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-red-500 hover:text-white focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-red-500 sm:ml-3 sm:w-auto"
          >
            <span class="text-gray-900 group-hover:text-white dark:text-white">
              <i class="fa-solid fa-circle-xmark" />
            </span>
            <span class="select-none">Back</span>
          </button>
          <!-- <button
            on:click={() => {
              dispatch("Continue")
            }}
            class="group flex h-9 min-h-full min-w-[36px] items-center justify-center gap-2 rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-blue-500 hover:text-white focus:outline-none sm:ml-3 sm:w-auto"
          >
            <span class="text-gray-900 group-hover:text-white">
              <i class="fa-solid fa-circle-chevron-right" />
            </span>
            <span class="select-none">Continue</span>
          </button> -->
          <button disabled={!disableBtn} type="submit" on:click|preventDefault={handleSubmit} class="dark:hover:bg-gree-500 group flex h-9 min-h-full min-w-[36px] items-center justify-center gap-2 rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-3 py-1.5 text-sm font-medium text-gray-900 hover:bg-green-500 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:bg-white/50 disabled:text-gray-100 disabled:hover:bg-none dark:bg-lightgray dark:text-white dark:hover:bg-green-500 sm:ml-3 sm:w-auto">
            <span class="text-gray-900 group-hover:text-white group-disabled:text-gray-100 dark:text-white">
              <i class="fa-solid fa-circle-check" />
            </span>
            <span class="select-none">Apply and Continue</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
